import React from 'react';
import styled from 'styled-components';

import {
  FormHeader, Desc, SmallDesc,
} from '../common/styles';

const Container = styled.div`
  background-color: ${props => props.theme.bodyBackgroundColor};
  border-radius: ${props => (props.theme.isMobile ? '4px' : '0')};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${props => (props.theme.isMobile ? '92%' : '33vw')};
  margin-top: ${props => (props.theme.isMobile ? '20px' : '0px')};

  ${props => (props.theme.isMobile ? `
    padding: 35px 15px 15px 15px;
    border-radius: 4px;
    border: 1px solid ${props.theme.secondaryColor30Transparent};
    justify-content: flex-start;
  ` : `
    max-width: 480px;
    justify-content: center;
    padding: 40px;
  `)}

  > ${Desc} {
    margin-top: ${props => (props.theme.isMobile ? '40px' : '50px')};
  }

  > ${SmallDesc} {
    margin-top: ${props => (props.theme.isMobile ? '40px' : '50px')};
    margin-bottom: 50px;
  }
`;

export default function CompletePane() {
  const anchorRef = React.useRef();

  React.useEffect(() => {
    setTimeout(() => anchorRef.current.click(), 10 * 1000);
  }, []);

  return (
    <Container>
      <FormHeader>
        You’ve successfully changed your password.
      </FormHeader>
      <Desc>
        We will redirect you to your login page shortly where you can log into your account.
        <br />
        <br />
        If you’re not redirected click the link below to return to the login page.
      </Desc>
      <SmallDesc>
        <a href="/sign_in" ref={anchorRef}>
          Return to Login
        </a>
      </SmallDesc>
    </Container>
  );
}
